import { DataValidationKinds } from "../DataValidationKinds";
import {
  IItem,
  ITextValidatable,
} from "../items";
import { AbstractInputRuleAlert } from "./AbstractInputRuleAlert";

export class InvalidTextAlert extends AbstractInputRuleAlert<IItem & ITextValidatable> {
  constructor(itemSetId: number, item: IItem & ITextValidatable) {
    super(itemSetId, item);
  }

  get itemName(): string {
    return this._detectedItem.getDisplayName();
  }

  get description(): string {
    switch (this._detectedItem.dataValidationKind) {
      case DataValidationKinds.FullWidth:
        return "全角で入力してください。";
      case DataValidationKinds.FullKana:
        return "全角カナで入力してください。";
      case DataValidationKinds.HalfKana:
        return "半角カナで入力してください。";
      case DataValidationKinds.HalfNumber:
        return "半角数字で入力してください。";
      case DataValidationKinds.AlphabetNumber:
        return "半角英数字記号で入力してください。";
      default:
        console.warn("不明な検証種別です。dataValidationKind: " + this._detectedItem.dataValidationKind);
        return "";
    }
  }
}
